<template>
  <v-container fluid class="pt-0">
    <v-row dense>
      <v-col cols="12" md="6" lg="4">
        <master-companies></master-companies>
      </v-col>
      <v-col cols="12" md="9" lg="4">
        <master-houses></master-houses>
      </v-col>
      <v-col cols="12" md="6" lg="4">
        <master-brands></master-brands>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import MasterBrands from '@/components/Master/MasterBrands.vue'
import MasterCompanies from '@/components/Master/MasterCompanies.vue'
import MasterHouses from '@/components/Master/MasterHouses.vue'
</script>
<style scoped>
</style>
